/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StageTypeEnum } from './StageTypeEnum';
import {
    StageTypeEnumFromJSON,
    StageTypeEnumFromJSONTyped,
    StageTypeEnumToJSON,
    StageTypeEnumToJSONTyped,
} from './StageTypeEnum';
import type { SubscriptionStatusEnum } from './SubscriptionStatusEnum';
import {
    SubscriptionStatusEnumFromJSON,
    SubscriptionStatusEnumFromJSONTyped,
    SubscriptionStatusEnumToJSON,
    SubscriptionStatusEnumToJSONTyped,
} from './SubscriptionStatusEnum';

/**
 * Serializer for Stage model with validation.
 * @export
 * @interface Stage
 */
export interface Stage {
    /**
     * 
     * @type {string}
     * @memberof Stage
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof Stage
     */
    venue: string;
    /**
     * 
     * @type {string}
     * @memberof Stage
     */
    readonly venueName: string;
    /**
     * 
     * @type {string}
     * @memberof Stage
     */
    readonly teamName: string;
    /**
     * 
     * @type {string}
     * @memberof Stage
     */
    name: string;
    /**
     * Maximum audience capacity
     * @type {number}
     * @memberof Stage
     */
    capacity?: number | null;
    /**
     * 
     * @type {StageTypeEnum}
     * @memberof Stage
     */
    stageType?: StageTypeEnum;
    /**
     * Stage technical specs: dimensions, sound system, lighting, etc.
     * @type {any}
     * @memberof Stage
     */
    technicalSpecs?: any | null;
    /**
     * 
     * @type {SubscriptionStatusEnum}
     * @memberof Stage
     */
    subscriptionStatus?: SubscriptionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Stage
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Stage
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Stage
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Stage
     */
    readonly updatedAt: Date;
}



/**
 * Check if a given object implements the Stage interface.
 */
export function instanceOfStage(value: object): value is Stage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('venue' in value) || value['venue'] === undefined) return false;
    if (!('venueName' in value) || value['venueName'] === undefined) return false;
    if (!('teamName' in value) || value['teamName'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function StageFromJSON(json: any): Stage {
    return StageFromJSONTyped(json, false);
}

export function StageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Stage {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'venue': json['venue'],
        'venueName': json['venue_name'],
        'teamName': json['team_name'],
        'name': json['name'],
        'capacity': json['capacity'] == null ? undefined : json['capacity'],
        'stageType': json['stage_type'] == null ? undefined : StageTypeEnumFromJSON(json['stage_type']),
        'technicalSpecs': json['technical_specs'] == null ? undefined : json['technical_specs'],
        'subscriptionStatus': json['subscription_status'] == null ? undefined : SubscriptionStatusEnumFromJSON(json['subscription_status']),
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function StageToJSON(json: any): Stage {
      return StageToJSONTyped(json, false);
  }

  export function StageToJSONTyped(value?: Omit<Stage, 'id'|'venue_name'|'team_name'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'venue': value['venue'],
        'name': value['name'],
        'capacity': value['capacity'],
        'stage_type': StageTypeEnumToJSON(value['stageType']),
        'technical_specs': value['technicalSpecs'],
        'subscription_status': SubscriptionStatusEnumToJSON(value['subscriptionStatus']),
        'description': value['description'],
        'is_active': value['isActive'],
    };
}

